import FilterTag from './filter-tag';

export default FilterTag;
